globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function GoogleIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      id: "logo_googleg_48dp",
      children: [/*#__PURE__*/_jsx("path", {
        id: "Shape",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.64 9.20419C17.64 8.56601 17.5827 7.95237 17.4764 7.36328H9V10.8446H13.8436C13.635 11.9696 13.0009 12.9228 12.0477 13.561V15.8192H14.9564C16.6582 14.2524 17.64 11.9451 17.64 9.20419Z",
        fill: "#4285F4"
      }), /*#__PURE__*/_jsx("path", {
        id: "Shape_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.00366 18.0009C11.4337 18.0009 13.4709 17.195 14.96 15.8205L12.0514 13.5623C11.2455 14.1023 10.2146 14.4214 9.00366 14.4214C6.65957 14.4214 4.67548 12.8382 3.96776 10.7109H0.960938V13.0428C2.44185 15.9841 5.48548 18.0009 9.00366 18.0009Z",
        fill: "#34A853"
      }), /*#__PURE__*/_jsx("path", {
        id: "Shape_3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.96409 10.7108C3.78409 10.1708 3.68182 9.59398 3.68182 9.0008C3.68182 8.40762 3.78409 7.8308 3.96409 7.2908V4.95898H0.957273C0.347727 6.17398 0 7.54853 0 9.0008C0 10.4531 0.347727 11.8276 0.957273 13.0426L3.96409 10.7108Z",
        fill: "#FBBC05"
      }), /*#__PURE__*/_jsx("path", {
        id: "Shape_4",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.00366 3.57955C10.325 3.57955 11.5114 4.03364 12.4441 4.92545L15.0255 2.34409C13.4668 0.891818 11.4296 0 9.00366 0C5.48548 0 2.44185 2.01682 0.960938 4.95818L3.96776 7.29C4.67548 5.16273 6.65957 3.57955 9.00366 3.57955Z",
        fill: "#EA4335"
      })]
    })
  });
}